export enum RoutesAddressEnum {
  ADDRESS_HOME = 'domicilio-particular' as any,
  ADDRESS_PROOF = 'comprobante-domicilio' as any,
  DELIVERY_ADDRESS = 'domicilio-recibir-tarjeta' as any,
  DELIVERY_TIME = 'hora-recibir' as any,
  ADDRESS_PROOF_FACEBOOK = 'comprobante-domicilio-facebook' as any
}
